module.exports = __webpack_public_path__ + "static/media/exercicio4.9acd2acb.png";